import React from 'react';

// Define the props interface
interface ServerMapPlaceholderProps {
  latitude?: number;
  longitude?: number;
  name?: string;
  address?: string;
  height?: string;
  width?: string;
  zoom?: number;
  className?: string;
  mapId?: string; // Unique ID for the map instance
}

/**
 * Server-side only version of the map placeholder
 * This component renders a simple placeholder during SSR
 * and doesn't attempt to load any map libraries
 */
const ServerMapPlaceholder: React.FC<ServerMapPlaceholderProps> = ({
  height = '400px',
  width = '100%',
  className = '',
  mapId = 'map-' + Math.random().toString(36).substring(2, 9) // Generate a random ID if not provided
}) => {
  const mapContainerId = `map-container-${mapId}`;
  
  return (
    <div
      id={mapContainerId}
      style={{
        height,
        width,
        backgroundColor: '#f0f0f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '8px'
      }}
      className={className}
      data-map-placeholder="true"
      data-map-id={mapId}
    >
      <p>Caricamento mappa...</p>
    </div>
  );
};

export { ServerMapPlaceholder };
